// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGArrowUp = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#arrowUp__clip0_12389_8154)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "arrowUp__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#arrowUp__clip1_12389_8154)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M22.6104 9.5664L16.8086 3.76367C16.3789 3.33398 15.6211 3.33398 15.1914 3.76367L9.38965 9.5664C8.94336 10.0127 8.94336 10.7363 9.39063 11.1826C9.83594 11.6279 10.5596 11.6289 11.0068 11.1816L14.8574 7.33031V27.4287C14.8574 28.0596 15.3691 28.5713 16 28.5713C16.6309 28.5713 17.1426 28.0596 17.1426 27.4287V7.33031L20.9932 11.1816C21.2168 11.4053 21.5088 11.5166 21.8018 11.5166C22.0938 11.5166 22.3867 11.4053 22.6094 11.1826C23.0567 10.7363 23.0566 10.0127 22.6104 9.5664Z"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#arrowUp__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "arrowUp__clip0_12389_8154",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "arrowUp__clip1_12389_8154",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGArrowUp.displayName = 'SVGArrowUp';
export default SVGArrowUp;